(() => {
'use strict';
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const initialized = new WeakSet();
try { if (sessionStorage.getItem('index-motion-paused') === 'true') document.documentElement.classList.add('motion-paused'); } catch { /* Storage can be unavailable in private browsing. */ }
const motionReduced = () => reduce.matches || document.documentElement.classList.contains('motion-paused');
function syncMotionControls() {
 const paused = document.documentElement.classList.contains('motion-paused');
 document.querySelectorAll('[data-motion-toggle]').forEach(button => {
  button.hidden = !document.querySelector('.orvyn-scene, [data-fragrance-profile]');
  button.disabled = reduce.matches;
  button.setAttribute('aria-pressed', String(paused || reduce.matches));
  button.textContent = reduce.matches ? 'Motion reduced by device' : paused ? 'Resume animations' : 'Pause animations';
 });
}
const clamp = n => Math.max(0, Math.min(1, n));
let frame = 0;
function fitHeadings() {
 document.querySelectorAll('[data-fit-heading]').forEach(heading => {
  heading.style.removeProperty('font-size');
  // CSS variable allows fitting without ever splitting a word or a deliberate line.
  heading.style.removeProperty('--heading-size');
  const base = parseFloat(getComputedStyle(heading).fontSize);
  const width = heading.clientWidth;
  let natural = heading.scrollWidth;
  for (const child of heading.children) natural = Math.max(natural, child.scrollWidth);
  if (width && natural > width) heading.style.setProperty('--heading-size', `${base * width / natural * .97}px`);
 });
}
function updateScroll() {
 frame = 0;
 const header = document.querySelector('.site-header');
 if (header) document.documentElement.style.setProperty('--site-header-height', `${header.getBoundingClientRect().height}px`);
 document.querySelectorAll('[data-story]').forEach(story => {
  const chapters = [...story.querySelectorAll('[data-chapter]')];
  if (!chapters.length) return;
  const rect = story.getBoundingClientRect();
  const progress = clamp(-rect.top / Math.max(1, rect.height - innerHeight));
  story.style.setProperty('--story-scroll', String(Math.max(.02, progress)));
  let active = 0, distance = Infinity;
  chapters.forEach((chapter,index) => { const r=chapter.getBoundingClientRect();const d=Math.abs(r.top+r.height/2-innerHeight/2); if(d<distance){active=index;distance=d;} });
  chapters.forEach((chapter,index)=>chapter.classList.toggle('is-active',index===active));
  story.querySelectorAll('[data-story-image]').forEach((image,index)=>{image.classList.toggle('is-active',index===active);image.setAttribute('aria-hidden',String(index!==active));});
  const current=chapters[active];
  story.querySelector('[data-story-word]').textContent=current.dataset.note;
  story.querySelector('[data-story-label]').textContent=current.dataset.label;
  story.querySelector('[data-story-metric]').textContent=current.dataset.metric;
  story.querySelector('[data-story-counter]').textContent=`${String(active+1).padStart(2,'0')} / ${String(chapters.length).padStart(2,'0')}`;
 });
}
function schedule(){if(!frame)frame=requestAnimationFrame(updateScroll);}
function selectNote(button) {
 const section=button.closest('[data-scent]');
 section.querySelectorAll('[data-scent-note]').forEach(note=>{const active=note===button;note.setAttribute('aria-pressed',String(active));note.classList.toggle('is-active',active);});
 section.querySelector('[data-note-name]').textContent=button.dataset.name;
 section.querySelector('[data-note-description]').textContent=button.dataset.description;
 
  const detail = section.querySelector('[data-note-detail]');
  if (detail) detail.textContent = button.dataset.description || '';

 section.querySelector('[data-dial]').style.setProperty('--dial-rotation',`${button.dataset.angle || 0}deg`);
}
function selectMode(button, focus=false) {
 const section=button.closest('[data-scent]');
 section.querySelectorAll('[data-mode]').forEach(tab=>{const active=tab===button;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;tab.classList.toggle('is-active',active);});
 section.querySelectorAll('[data-mode-panel]').forEach(panel=>panel.hidden=panel.dataset.modePanel!==button.dataset.mode);
 section.querySelector('[data-diffusion]').className=`diffusion diffusion-${button.dataset.mode}`;
 if(focus)button.focus();
}
function initialize(root=document) {
 
 [...(root.matches?.('[data-story], [data-scent], [data-atelier]') ? [root] : []), ...root.querySelectorAll('[data-story], [data-scent], [data-atelier]')].forEach(section=>{

  if(initialized.has(section))return; initialized.add(section);section.classList.add('is-enhanced');
  if(section.matches('[data-scent]')){
   const notes=[...section.querySelectorAll('[data-scent-note]')];const count=Math.min(notes.length,8);
   let overflow;
   notes.forEach((note,index)=>{
    const angle=count===4?[-138,-42,42,138][index]:-90+index*360/count;
    note.dataset.angle=String(angle);
    if(index<count){note.style.left=`${50+39*Math.cos(angle*Math.PI/180)}%`;note.style.top=`${50+39*Math.sin(angle*Math.PI/180)}%`;}
    else{if(!overflow){overflow=document.createElement('div');overflow.className='note-overflow';section.querySelector('.dial-panel').append(overflow);}overflow.append(note);}
   });
   if(notes.length)selectNote(notes[Math.min(1,notes.length-1)]);
   selectMode(section.querySelector('[data-mode="halo"]'));
  }
 });
 syncMotionControls();fitHeadings();schedule();
}
document.addEventListener('click',event=>{
 const motion = event.target.closest('[data-motion-toggle]');
 if (motion && !reduce.matches) {
  const paused = document.documentElement.classList.toggle('motion-paused');
  try { sessionStorage.setItem('index-motion-paused', String(paused)); } catch { /* The current page still honors the control. */ }
  document.querySelectorAll('[data-bottle],[data-tilt-panel],[data-magnetic]').forEach(resetPointer);
  syncMotionControls();
 }
 const note=event.target.closest('[data-scent-note]');if(note)selectNote(note);
 const mode=event.target.closest('[data-mode]');if(mode)selectMode(mode);
 const finish=event.target.closest('[data-finish]');if(finish&&!finish.disabled){
  const section=finish.closest('[data-atelier]');section.querySelectorAll('[data-finish]').forEach(b=>{b.setAttribute('aria-pressed',String(b===finish));b.classList.toggle('is-active',b===finish);});
  section.querySelectorAll('[data-finish-image]').forEach(image=>image.hidden=image.dataset.finishImage!==finish.dataset.finish);
  section.querySelector('[data-finish-label]').textContent=finish.dataset.finish.toUpperCase();
 }
});
document.addEventListener('input',event=>{
 const input=event.target;
 if(input.matches('[data-monogram]')){input.value=input.value.toUpperCase().replace(/[^A-Z]/g,'').slice(0,2);input.closest('[data-atelier]').querySelectorAll('[data-monogram-preview]').forEach(el=>el.textContent=input.value||'—');}
 if(input.matches('[data-depth]')){const section=input.closest('[data-atelier]');section.querySelector('.configurator-stage').style.setProperty('--engraving-depth',String(Number(input.value)/100));section.querySelector('[data-depth-output]').textContent=`${input.value}%`;}
});
document.addEventListener('keydown',event=>{
 const current=event.target.closest('[data-mode], [data-scent-note]');if(!current)return;
 if(!['ArrowRight','ArrowLeft','ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
 event.preventDefault();const isMode=current.hasAttribute('data-mode');const list=[...current.closest('[data-scent]').querySelectorAll(isMode?'[data-mode]':'[data-scent-note]')];let next=list.indexOf(current);
 if(event.key==='Home')next=0;else if(event.key==='End')next=list.length-1;else next=(next+(['ArrowRight','ArrowDown'].includes(event.key)?1:-1)+list.length)%list.length;
 if(isMode)selectMode(list[next],true);else{selectNote(list[next]);list[next].focus();}
});
document.addEventListener('pointermove',event=>{
 if(event.pointerType!=='mouse'||motionReduced())return;
 const hero=event.target.closest('[data-hero].motion-enabled');if(hero){const r=hero.getBoundingClientRect();hero.style.setProperty('--hero-light-x',`${(event.clientX-r.left)/r.width*100}%`);hero.style.setProperty('--hero-light-y',`${(event.clientY-r.top)/r.height*100}%`);}
 const target=event.target.closest('[data-bottle],[data-tilt-panel],[data-magnetic]');if(!target)return;
 if(target.closest('[data-hero]:not(.motion-enabled)'))return;
 const r=target.getBoundingClientRect(),x=(event.clientX-r.left)/r.width-.5,y=(event.clientY-r.top)/r.height-.5;
 if(target.hasAttribute('data-bottle')){target.style.setProperty('--bottle-rotate-x',`${-y*8}deg`);target.style.setProperty('--bottle-rotate-y',`${x*12}deg`);target.style.setProperty('--bottle-light-x',`${(x+.5)*100}%`);target.style.setProperty('--bottle-light-y',`${(y+.5)*100}%`);}
 if(target.hasAttribute('data-tilt-panel')){target.style.setProperty('--tilt-x',`${-y*7}deg`);target.style.setProperty('--tilt-y',`${x*9}deg`);target.style.setProperty('--spot-x',`${(x+.5)*100}%`);target.style.setProperty('--spot-y',`${(y+.5)*100}%`);}
 if(target.hasAttribute('data-magnetic')){target.style.setProperty('--magnetic-x',`${x*r.width*.12}px`);target.style.setProperty('--magnetic-y',`${y*r.height*.12}px`);}
});
function resetPointer(target){for(const property of ['--bottle-rotate-x','--bottle-rotate-y','--tilt-x','--tilt-y','--magnetic-x','--magnetic-y','--bottle-light-x','--bottle-light-y','--spot-x','--spot-y'])target.style.removeProperty(property);}
document.addEventListener('pointerout',event=>{const target=event.target.closest('[data-bottle],[data-tilt-panel],[data-magnetic]');if(target&&!target.contains(event.relatedTarget))resetPointer(target);});
reduce.addEventListener('change',()=>{syncMotionControls();document.querySelectorAll('[data-bottle],[data-tilt-panel],[data-magnetic]').forEach(resetPointer);schedule();});
window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',()=>{fitHeadings();schedule();},{passive:true});
document.addEventListener('shopify:section:load',event=>initialize(event.target));document.addEventListener('shopify:section:unload',schedule);
document.addEventListener('shopify:block:select',event=>{const chapter=event.target.closest('[data-chapter]');if(chapter)chapter.scrollIntoView({block:'center',behavior:'auto'});});

// Progressive enhancement: without JavaScript every available information panel stays readable.
const profileInstances = new WeakSet();
function selectProfileTab(profile, selected, focus = false) {
 profile.querySelectorAll('[data-profile-tab]').forEach(tab => {
  const active = tab === selected;
  tab.setAttribute('aria-selected', String(active));
  tab.tabIndex = active ? 0 : -1;
 });
 profile.querySelectorAll('[data-profile-panel]').forEach(panel => {
  panel.hidden = panel.dataset.profilePanel !== selected.dataset.profileTab;
 });
 if (focus) selected.focus();
}
function initializeProfiles(root = document) {
 root.querySelectorAll('[data-fragrance-profile]').forEach(profile => {
  if (profileInstances.has(profile)) return;
  profileInstances.add(profile);
  const tabs = [...profile.querySelectorAll('[data-profile-tab]')];
  if (tabs.length < 2) return;
  const tablist = profile.querySelector('[data-profile-tabs]');
  tablist.setAttribute('role', 'tablist');
  tabs.forEach(tab => {
   tab.setAttribute('role', 'tab');
   const panel = profile.querySelector(`[data-profile-panel="${tab.dataset.profileTab}"]`);
   panel.setAttribute('role', 'tabpanel');
   panel.setAttribute('aria-labelledby', tab.id);
   panel.tabIndex = 0;
  });
  selectProfileTab(profile, tabs[0]);
  tablist.hidden = false;
  profile.classList.add('is-profile-enhanced');
 });
}
document.addEventListener('click', event => {
 const tab = event.target.closest('[data-profile-tab]');
 if (tab) selectProfileTab(tab.closest('[data-fragrance-profile]'), tab);
});
document.addEventListener('keydown', event => {
 const tab = event.target.closest('[data-profile-tab]');
 if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
 event.preventDefault();
 const profile = tab.closest('[data-fragrance-profile]');
 const tabs = [...profile.querySelectorAll('[data-profile-tab]')];
 let index = tabs.indexOf(tab);
 if (event.key === 'Home') index = 0;
 else if (event.key === 'End') index = tabs.length - 1;
 else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
 selectProfileTab(profile, tabs[index], true);
});
document.addEventListener('shopify:section:load', event => initializeProfiles(event.target));
initializeProfiles();

initialize();document.fonts?.ready.then(fitHeadings);
})();
